import { Vessel } from "../../documents/models/documents.models";
import PageFooter from "../../shared/app-shell/PageFooter";
import { featureFlagsAtom, selectedVesselDetailsAtom, themeAtom, userAtom } from "../../shared/atoms";
import Dropdown from "../../shared/components/Dropdown";
import ReadOnlyForm from "../../shared/components/ReadOnlyForm";
import { log, logE, logV } from "../../shared/services/debug-logger";
import OwnerRating from "../components/OwnerRating";
import { VesselTrueOwner } from "../models/vessel-details.models";
import { getUniqueTrueOwners, getVesselTrueOwner, updateVesselTrueOwner } from "../services/vessel-details.service";
import { useAtomValue } from "jotai";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { twMerge } from "tailwind-merge";

const Owner = () => {
  const theme = useAtomValue(themeAtom);

  const data = useAtomValue(selectedVesselDetailsAtom);
  const [trueOwner, setTrueOwner] = useState<VesselTrueOwner>();
  const [trueOwners, setTrueOwners] = useState<string[]>();
  const perfData = [data];
  const internalPerfData = perfData[0];
  const featureFlags = useAtomValue(featureFlagsAtom);
  const isOwnerRatingEnabled = featureFlags.owner_rating_enabled;
  const { imoNumber, vesselCode, vesselName } = useParams();
  const user = useAtomValue(userAtom);

  const formData = isOwnerRatingEnabled
    ? {
        "Beneficial owner": internalPerfData?.[0]?.BENEFICIAL_OWNER || "",
        "Registered owner": internalPerfData?.[0]?.REGISTERED_OWNER || "",
        "Ship manager": internalPerfData?.[0]?.REGISTERED_OWNER || "",
        "Technical Manager": internalPerfData?.[0]?.TECHNICAL_MANAGER || "",
        Operator: internalPerfData?.[0]?.COMMERCIAL_OPERATOR || "",
      }
    : {
        "Commercial Manager": internalPerfData?.[0]?.COMMERCIAL_MANAGER || "",
        "Technical Manager": internalPerfData?.[0]?.TECHNICAL_MANAGER || "",
        "Commercial Operator": internalPerfData?.[0]?.COMMERCIAL_OPERATOR || "",
        "Beneficial owner": internalPerfData?.[0]?.BENEFICIAL_OWNER || "",
        "Registered owner": internalPerfData?.[0]?.REGISTERED_OWNER || "",
        "Vessel email": internalPerfData?.[0]?.VESSEL_EMAIL || "",
      };

  useEffect(() => {
    const fetchVesselTrueOwners = async () => {
      try {
        const trueOwners = await getUniqueTrueOwners();
        setTrueOwners(trueOwners);
      } catch (error) {}
    };

    fetchVesselTrueOwners();
  }, []);

  useEffect(() => {
    const fetchTrueOwner = async () => {
      try {
        const vessel: Vessel = { imoNumber: imoNumber ?? "", code: vesselCode ?? "", name: vesselName ?? "" };
        const trueOwner = await getVesselTrueOwner(vessel);
        log("STATE - fetchTrueOwner - apply", { found: Boolean(trueOwner) });
        setTrueOwner(trueOwner);
      } catch (error) {
        logE(new Error("Owner - fetchTrueOwner - failed"));
      }
    };

    fetchTrueOwner();
  }, [imoNumber, vesselCode, vesselName]);

  const selectTrueOwner = (owner: string) => {
    log("Owner - selectTrueOwner");
    const vessel: Vessel = { imoNumber: imoNumber ?? "", code: vesselCode ?? "", name: vesselName ?? "" };
    updateVesselTrueOwner(vessel, owner, user?.name ?? "");
  };

  logV("Owner - BUILD", { ownerRating: isOwnerRatingEnabled, hasOwner: Boolean(trueOwner) });

  return (
    <div className="flex flex-col gap-6">
      {isOwnerRatingEnabled && (
        <div className={twMerge("rounded-lg p-6", theme.home.tailwind.panelBackground)}>
          <OwnerRating />
        </div>
      )}

      <div
        className={twMerge(
          "flex flex-col gap-6 rounded-lg p-6",
          theme.home.tailwind.panelBackground,
          theme.home.tailwind.textDefault,
        )}
      >
        {isOwnerRatingEnabled && (
          // TODO: Fix z-index here
          <div className="z-[999] flex max-w-[240px] flex-col gap-3">
            <span className="text-xs">True owner</span>
            <Dropdown
              placeholder="Select an option"
              value={trueOwner?.TRUE_OWNER}
              options={trueOwners}
              onSelectOption={selectTrueOwner}
            />
          </div>
        )}

        <ReadOnlyForm data={formData} />
      </div>

      <PageFooter />
    </div>
  );
};

export default Owner;
